import { NextRequest } from 'next/server';
import { ExperimentFetcherConfig, ExperimentFetcherConfigFromAction } from './types';
import { EXPERIMENTS_SESSION_ID } from './const';
import retrieveIp from '../ipHandler';

/**
 * Aggregates the configuration for experiments
 */
export function builder() {
  async function fromNextRequest(request: NextRequest): Promise<ExperimentFetcherConfig> {
    return {
      isDisabled:
        process.env.DISABLE_EXPERIMENTS === 'true' || request.nextUrl.searchParams.get('noExp') === 'true',
      experimentSessionId: request.cookies.get(EXPERIMENTS_SESSION_ID)?.value ?? null,
      searchParams: request.nextUrl.searchParams,
      headers: {
        ip: await retrieveIp(request.headers).catch(() => null),
        userAgent: request.headers.get('user-agent'),
        url: request.url,
        referrer: request.headers.get('referer'),
      },
    };
  }

  function fromAction(config: ExperimentFetcherConfigFromAction): ExperimentFetcherConfig {
    const searchParams = new URLSearchParams(config.searchParams);
    return {
      isDisabled: process.env.DISABLE_EXPERIMENTS === 'true' || searchParams?.get('noExp') === 'true',
      experimentSessionId: config.experimentSessionId,
      searchParams,
      headers: {
        ip: config.ip,
        userAgent: config.userAgent,
        url: config.url,
        referrer: config.referrer,
      },
    };
  }

  return {
    fromNextRequest,
    fromAction,
  };
}

export default {
  isDisabled: process.env.EXPERIMENTS_DISABLED === 'true',
  apiUrl: process.env.LARAVEL_API || '',
  apiKey: process.env.LARAVEL_INTERNAL_API_KEY || '',
  analytics: {
    enabled: process.env.NEXT_PUBLIC_ANALYTICS_ENABLE !== 'false',
    ga4Key: process.env.NEXT_PUBLIC_GA4 || '',
  },
};
